import './CurrentWorkspaceSelector.scss';
import { useTranslator } from '@Localization';
import { AutocompleteOption } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IWorkspace } from '../../../../../__legacy__/modules/workspaces/workspaces.store';
import { Select } from '../../../../../design/inputs/select/Select';
import { CurrentWorkspaceSelectorOption } from './option/CurrentWorkspaceSelectorOption';

interface IProps {
  workspaces: IWorkspace[];
  currentWorkspace: IWorkspace | undefined;
  isLoading: boolean | undefined;
  onRefresh: () => Promise<void>;
  onSelected: (id: string) => void;
}

export const CurrentWorkspaceSelector = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <div
      id='current-workspace-navigation-item'
      className='current-workspace-selector'
    >
      <div className='current-workspace-selector-label'>{t('current_workspace')}</div>
      <Select
        className='current-workspace-selector-select'
        id='current-workspace-dropdown'
        value={props.workspaces.find((x) => x.id === props.currentWorkspace?.id)}
        onOpen={() => {
          void props.onRefresh();
        }}
        loading={props.isLoading}
        onChange={(_, v) => {
          props.onSelected(v.id);
        }}
        options={props.workspaces}
        getOptionDisabled={(option) => option.locked}
        getOptionLabel={(o) => o.name}
        getOptionKey={(o) => o.id}
        renderOption={(optionPropsWithKey, option) => {
          const { key, ...optionProps } = optionPropsWithKey as unknown as Omit<React.HTMLAttributes<HTMLLIElement>, 'color'> & { key: string };
          return (
            <AutocompleteOption
              {...optionProps}
              key={key}
            >
              <CurrentWorkspaceSelectorOption workspace={option} />
            </AutocompleteOption>
          );
        }}
      />
    </div>
  );
});
